import {createContext} from "react"

import {InMemoryCache} from "@apollo/client"

import {DomainUser, TenantUser} from "src/_generated/typed-document-nodes"

import {Tenant} from "../utils/@types/TenantInterface"
import {initialDomainUser} from "../utils/Queries/domainUsers"
import {initialTenantUser} from "../utils/Queries/tenantUsers"

export type ErrorContextType = {
    isError: boolean
    message: string
    generateError: (message: string) => void
    cache: InMemoryCache
    globalLoading: boolean
    setGlobalLoading: Function
    currentTenant: Tenant
    setCurrentTenant: (tenent: Tenant) => void
    currentTenantUser: TenantUser
    currentDomainUser: DomainUser
    setCurrentTenantUser: (user: TenantUser) => void
    setCurrentDomainUser: (user: DomainUser) => void
}

const ErrorContext = createContext<ErrorContextType>({
    isError: false,
    message: "",
    generateError: (message: string) => {},
    cache: new InMemoryCache(),
    globalLoading: false,
    currentTenant: {
        id: "",
        domainId: "",
        domainName: "",
        parentDomainId: "",
        parentDomainName: "",
        name: "",
        phone: "",
        email: "",
        address: {
            name: "",
            additionalInfo: "",
            additionalGeographicInfo: "",
            street: "",
            postBox: "",
            zipCode: "",
            city: "",
            country: ""
        },
        omsServiceAccount: null,
        authorizedProductIds: [],
        isEnabled: true
    },
    currentTenantUser: initialTenantUser,
    setGlobalLoading: () => {},
    setCurrentTenant: () => {},
    setCurrentTenantUser: () => {},
    currentDomainUser: initialDomainUser,
    setCurrentDomainUser: () => {}
})

export default ErrorContext
